import { Col, Divider, Row, Typography } from 'antd'
import Input from 'components/Input'
import { DatepickerValue, InputFieldTypes } from 'components/Input/types'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext } from 'react'
import { NpvrSearchFormFields } from '../../redux/useSearchForm'
import { SOURCE_OPTIONS } from './types'

type MoreFiltersProps = {
  showMoreFilters: boolean
  setStringValue: (key: NpvrSearchFormFields, value: string) => void
  setDateValue: (key: NpvrSearchFormFields, value: DatepickerValue)=> void
  stringSearchForm: Map<NpvrSearchFormFields, string>
  dateSearchForm: Map<NpvrSearchFormFields, {
    start: string;
    end: string;
  }>
}

export default function MoreFilters({ showMoreFilters, setStringValue, setDateValue, stringSearchForm, dateSearchForm}: MoreFiltersProps) {
  const t = useContext(I18nContext)

  return (
    <div className={`npvr-filters ${showMoreFilters?'active':'collapsed'}`}>
      <Row gutter={16}>
        <Col span={8}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.column_channel')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
        <Col span={8}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.column_start_time')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
        <Col span={8}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.column_end_time')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
      </Row>
    <Row gutter={16}>
      <Col span={4}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.channel)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.channel, value)}
          labelParams={{
            i18nTag: 'dvr.field_channel',
            onClean: () => setStringValue(NpvrSearchFormFields.channel, '')
          }}
        />
      </Col>
      <Col span={4}>
        <Input
          type={InputFieldTypes.text}
          value={stringSearchForm.get(NpvrSearchFormFields.channelNumber)}
          setValue={(value) => setStringValue(NpvrSearchFormFields.channelNumber, value)}
          labelParams={{
            i18nTag: 'dvr.column_channel_number',
            onClean: () => setStringValue(NpvrSearchFormFields.channelNumber, '')
          }}
        />
      </Col>
      <Col span={8}>
        <Input
          type={InputFieldTypes.datePicker}
          value={dateSearchForm.get(NpvrSearchFormFields.startTime)}
          setValue={(value) => setDateValue(NpvrSearchFormFields.startTime, value)}
          labelParams={{
            i18nTag: 'dvr.column_start_time',
            onClean: () => setDateValue(NpvrSearchFormFields.startTime, {start: "", end: ""})
          }}
        /> 
      </Col>
      <Col span={8}>
        <Input
          type={InputFieldTypes.datePicker}
          value={dateSearchForm.get(NpvrSearchFormFields.endTime)}
          setValue={(value) => setDateValue(NpvrSearchFormFields.endTime, value)}
          labelParams={{
            i18nTag: 'dvr.column_end_time',
            onClean: () => setDateValue(NpvrSearchFormFields.endTime, {start: "", end: ""})
          }}
        /> 
      </Col>
    </Row>
    <Row gutter={16}>
        <Col span={10}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.label_management')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
        <Col span={7}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.column_actual_start_time')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
        <Col span={7}>
          <Typography.Title level={4} className='npvr-section-title'>{t('dvr.column_actual_end_time')}</Typography.Title>
          <Divider className='npvr-title-divider'/>
        </Col>
      </Row>
    <Row gutter={16}>
      <Col span={4}>
        <Input 
        type={InputFieldTypes.select}
        options={SOURCE_OPTIONS}
        setValue={(value) => setStringValue(NpvrSearchFormFields.source, value)}
        value={stringSearchForm.get(NpvrSearchFormFields.source)}
        labelParams={{
          i18nTag: 'dvr.column_source',
          onClean: () => setStringValue(NpvrSearchFormFields.source, SOURCE_OPTIONS[0].value)
        }}
        />
      </Col>
      <Col span={6}>
        <Input
          type={InputFieldTypes.datePicker}
          value={dateSearchForm.get(NpvrSearchFormFields.lastEvent)}
          setValue={(value) => setDateValue(NpvrSearchFormFields.lastEvent, value)}
          labelParams={{
            i18nTag: 'dvr.field_lastEvent',
            onClean: () => setDateValue(NpvrSearchFormFields.lastEvent, {start: "", end: ""})
          }}
        />
      </Col>
      <Col span={7}>
       <Input
          type={InputFieldTypes.datePicker}
          value={dateSearchForm.get(NpvrSearchFormFields.actualStartTime)}
          setValue={(value) => setDateValue(NpvrSearchFormFields.actualStartTime, value)}
          labelParams={{
            i18nTag: 'dvr.column_actual_start_time',
            onClean: () => setDateValue(NpvrSearchFormFields.actualStartTime, {start: "", end: ""})
          }}
        />
      </Col>
      <Col span={7}>
        <Input
          type={InputFieldTypes.datePicker}
          value={dateSearchForm.get(NpvrSearchFormFields.actualEndTime)}
          setValue={(value) => setDateValue(NpvrSearchFormFields.actualEndTime, value)}
          labelParams={{
            i18nTag: 'dvr.column_actual_end_time',
            onClean: () => setDateValue(NpvrSearchFormFields.actualEndTime, {start: "", end: ""})
          }}
        />
      </Col>
    </Row>
    </div>
  )
}
